module.exports = __webpack_public_path__ + "img/pied-piper-square.0a42e783.svg";